import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import jwtDecode from 'jwt-decode';
// Model
import { UserContextModel } from '../user-context.model';
// Services
import { ApiService } from '../../service/api.service';
import { AppService } from '../../service/app.service';
import { SystemApiService } from '../../service/system-api.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
	constructor(
		private api: ApiService,
		private appService: AppService,
		private systemApi: SystemApiService
	) {	}

	/**
	 * Execute when there is a new Update in the App to retrieve more information like Navigation
	 * @param appState
	 */
	loginAppUpdate(appState: any): Observable<UserContextModel> {
		return this.api.post('/auth/app/update').pipe(
			map(payload => {
				const user = new UserContextModel();
				if (payload.token) {
					const { navItems, schema }: any = jwtDecode(payload.token);
					user.id = appState.update.context.id;
					user.name = appState.update.context.name;
					user.email = appState.update.context.email;
					user.isActive = appState.update.context.isActive;
					user.token = payload.token;
					user.navItems = navItems;
					user.schema = schema;
				}
				return user;
			})
		);
	}

	/**
	 * get user config data
	 * @param token
	 */
	setUserData(token: string): Observable<UserContextModel> {
		const user = new UserContextModel();
		if (token) {
			const userInfo: any = jwtDecode(token);

			return this.appService.getUserData(userInfo, token);
		}
		return of(user);
	}

	/**
	 * Update user data using the token
	 *
	 * @param token
	 */
	getUserDataFromToken(token: string): Observable<UserContextModel> {
		const user = new UserContextModel();
		if (token) {
			const userInfo: any = jwtDecode(token);

			return this.appService.getUserDataFromToken(userInfo, token);
		}

		return of(user);
	}

	/**
	 * Gettin cookies from cloud front
	 * @param token
	 */
	async setCloudFrontSignCookies(token: string): Promise<void> {
		const headers = new Headers();
		headers.append('Authorization', 'Bearer ' + token);

		await fetch(this.systemApi.api.cloudFrontSign, {
			method: 'GET',
			headers: headers,
			credentials: 'include'
		});
	}
}
